import { Injectable } from '@angular/core';
import { SettingsService } from '@barthauer/abc/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { DataService } from '@barthauer/abc/core/data';
import { LoginSettingsService, ProfileSettingsService } from '@barthauer/abc/core/authentication';
import { IDataFormSettings, DataFormSettings, DataFormSetting } from '../core/models/dataform-settings.model';

@Injectable({ providedIn: 'root' })
export class DataFormSettingsService extends SettingsService<IDataFormSettings, DataFormSettings, DataFormSetting> {
  constructor(
    abcConfigService: AbcConfigService,
    data: DataService,
    loginSettingsService: LoginSettingsService,
    profileSettingsService: ProfileSettingsService
  ) {
    super(
      abcConfigService,
      data,
      loginSettingsService,
      profileSettingsService,
      'DataFormSettings',
      DataFormSettings,
      DataFormSetting
    );
  }
}